module.exports = __webpack_public_path__ + "img/xyjws.e5cd2c85.png";